export const environment = {
  apiBaseUrl: 'https://grupo3.jyaa-ci.linti.unlp.edu.ar/rest',
};
